import React, { useState } from "react";
import StatsCard from "../UI/staticsCard";
import DataTable from "../UI/table/DataTable";
import { useQuery } from "react-query";
import {
  getShippingPriciesStatics,
  getShippingPricing,
} from "../../MyApi/shippingprice";
import { shippingPriceColumns, shippingPricesStatcs } from "../../pages/shipping/shippingdata";

const PricingTab = ({ onAddClick }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isLoading  ,error ,refetch} = useQuery(["getShippingpricing",currentPage], ()=>getShippingPricing(currentPage));
  const { data: shippingpricingstatsData ,isLoading :loadingStatsShippingPrices } = useQuery(
    "getShippingpricingstats",
    getShippingPriciesStatics
  );

  const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;
  const shippingPricesStatcscounts = shippingpricingstatsData?.data || {};

  const shippingPriceStatcs = shippingPricesStatcs(shippingPricesStatcscounts);

  // دالة لمعالجة بيانات التسعير وعرضها بشكل مناسب
  const processShippingPrices = (shippingPrices) => {
    if (!shippingPrices || !Array.isArray(shippingPrices)) return [];

    return shippingPrices.flatMap((zone) => {
      // إذا كانت المنطقة لا تحتوي على بيانات
      if (!zone.name || !zone.base_prices || zone.base_prices.length === 0) {
        return [
          {
            zone_name: zone.name || "غير محدد",
            vehicle_name: "لا توجد بيانات",
            base_price: "-",
            max_price: "-",
            per_km_price: "-",
            max_cod_price: "-",
            enable_cod: "-",
            is_active: zone.is_active,
          },
        ];
      }

      // إنشاء صف لكل مركبة في المنطقة
      return zone.base_prices.map((basePrice, index) => {
        const maxPrice = zone.max_prices?.[index];
        const perKmPrice = zone.per_km_prices?.[index];
        const maxCodPrice = zone.max_cod_prices?.[index];
        const enableCod = zone.enable_cods?.[index];

        return {
          id:zone.id,
          zone_name: zone.name,
          vehicle_name: basePrice.vehicle_name,
          base_price: basePrice.base_price,
          max_price: maxPrice?.max_price || "-",
          per_km_price: perKmPrice?.per_km_price || "-",
          max_cod_price: maxCodPrice?.max_cod_price || "-",
          enable_cod: enableCod?.enable_cod ? "مفعل" : "معطل",
          is_active: zone.is_active,
          active_orders_count: zone.active_orders_count,
          total_couriers_count: zone.total_couriers_count,
          shipping_price_id: maxPrice.shipping_price_id,
          currency_factor: zone.currency_factor
        };
      });
    });
  };

  const shippingprices = processShippingPrices(
    data?.data?.ShippingPrices || []
  );

  return (
    <>
      <div className="row g-3 mt-3">
        {shippingPriceStatcs?.map((stat, index) => (
          <div className="col-md" key={index}>
            <StatsCard {...stat} isLoading={loadingStatsShippingPrices} />
          </div>
        ))}
      </div>

      <div className="mt-4">
        <DataTable
          title={"تسعير المناطق"}
          actionLabel={"إضافة منطقة تسعير"}
          columns={shippingPriceColumns}
          data={shippingprices}
          emptyMessage="لا توجد بيانات لتسعير المناطق"
          onAddClick={onAddClick}
          itemsPerPage={lastPage}
          totalItems={totalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={isLoading}
          createPermission={"create_shipping_price"}
          error={error}
          onRetry={()=>refetch()}
          
        />
      </div>
    </>
  );
};

export default PricingTab;
